import { useEffect, useState } from "react";
import { SupabaseClient, createClient } from "@supabase/supabase-js";
import config from "../config";

const useSupabase = () => {
  const [supabaseClient, setSupabaseClient] = useState<SupabaseClient<
    any,
    "public"
  > | null>(null);

  useEffect(() => {
    const client = createClient(config.SUPABASE_URL, config.SUPABASE_KEY);
    setSupabaseClient(client);

    return () => {
      setSupabaseClient(null);
    };
  }, []);

  return supabaseClient;
};

export default useSupabase;
